export default __webpack_public_path__ + "static/media/left-arrow.3b8dccec.svg";